import * as yup from "yup";

import { CustomerBusinessData } from "./customer-model";
import { useFormik } from "formik";
import { useTranslation } from "next-i18next";

/**
 * Manages form data for customer data step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useCustomerBusinessFormik(
  onNext: (data: CustomerBusinessData) => void
) {
  const { t } = useTranslation();
  const messageRequired = t("common:common.required");
  const messageTextOnly = t("common:common.text_only");
  const messageNumbersOnly = t("common:common.numbers_only");

  const expressionTextOnly = /^([^0-9@&*"']*)$/;
  const expressionNumbersOnly = /^([0-9@&*\-]*)$/;

  const validationSchema = yup.object().shape({
    companyName: yup
      .string()
      .required(messageRequired)
      .matches(expressionTextOnly, messageTextOnly),
    countryOfBusiness: yup
      .string()
      .required(messageRequired)
      .matches(expressionTextOnly, messageTextOnly),
    address: yup.string().required(messageRequired),
    city: yup
      .string()
      .required(messageRequired)
      .matches(expressionTextOnly, messageTextOnly),
    state: yup
      .string()
      .required(messageRequired)
      .matches(expressionTextOnly, messageTextOnly),
    zipCode: yup
      .string()
      .required(messageRequired)
      .matches(expressionNumbersOnly, messageNumbersOnly),
  });

  const formik = useFormik<CustomerBusinessData>({
    initialValues: {
      companyName: "",
      countryOfBusiness: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
    },
    validationSchema: validationSchema,
    // use handleSubmission instead
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}
